import React from 'react';
import { func, shape } from 'prop-types';
import { Formik } from 'formik';

import FiltersForm from './FiltersForm';

const Form = props => {
  const { onSubmit, filters } = props;

  return (
    <Formik onSubmit={onSubmit} initialValues={filters}>
      {({ handleSubmit, values, setFieldValue }) => (
        <FiltersForm
          values={values}
          onSubmit={handleSubmit}
          setValue={setFieldValue}
          {...props}
        />
      )}
    </Formik>
  );
};

Form.propTypes = {
  onSubmit: func.isRequired,
  filters: shape({}),
};

Form.defaultProps = {
  filters: null,
};

export default Form;
